import { Link } from "@reach/router";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import theTextFile from "../assets/md/service.md";
import Layout from "../components/Layout";
const Page = (props: any) => {
  const [postMarkdown, setPostMarkdown] = useState("");
  useEffect(() => {
    fetch(theTextFile)
      .then((response) => response.text())
      .then((text) => {
        setPostMarkdown(text);
      });
  }, []);

  return (
    <Layout>
      <Main>
        <ReactMarkdown remarkPlugins={[gfm]}>{postMarkdown}</ReactMarkdown>
      </Main>
    </Layout>
  );
};

const Main = styled.div`
  direction: rtl;
  text-align: right;
  padding: 46px;
  overflow: auto;
  height: 100vh;
  background-color: #fff;
  color: #222;
  a {
    color: #567abd;
  }
`;

export default Page;
